import { useMemo } from "react";
import { useQuery } from "@apollo/client";
import { cmsClient } from "@/lib/cmsClient";
import type { Product, ProductType } from "../product.types";
import {
    parseSunProtections,
    parseWindowDecorations,
} from "../mappers/product.parse";
import GET_SUN_PROTECTIONS from "../graphql/GetSunProtections.graphql";
import GET_WINDOW_DECORATIONS from "../graphql/GetWindowDecorations.graphql";

export function useProducts(category: ProductType | null) {
    const isSunProtection = category === "SUN_PROTECTION";
    const isWindowDecoration = category === "WINDOW_DECORATION";

    const sunProtectionQuery = useQuery<unknown>(GET_SUN_PROTECTIONS, {
        client: cmsClient,
        skip: !isSunProtection,
    });

    const windowDecorationQuery = useQuery<unknown>(GET_WINDOW_DECORATIONS, {
        client: cmsClient,
        skip: !isWindowDecoration,
    });

    const products: Product[] = useMemo(() => {
        if (isSunProtection) {
            return parseSunProtections(sunProtectionQuery.data);
        }
        if (isWindowDecoration) {
            return parseWindowDecorations(windowDecorationQuery.data);
        }
        return [];
    }, [
        isSunProtection,
        isWindowDecoration,
        sunProtectionQuery.data,
        windowDecorationQuery.data,
    ]);

    const loading = isSunProtection
        ? sunProtectionQuery.loading
        : isWindowDecoration
          ? windowDecorationQuery.loading
          : false;

    const error = isSunProtection
        ? sunProtectionQuery.error
        : isWindowDecoration
          ? windowDecorationQuery.error
          : null;

    return { products, loading, error };
}
